import { UseMutationOptions, useMutation } from 'react-query';
import { TRunnerBody } from './runnerStatus.types';
import { mutateRunnerStatus } from './runnerStatus';

export const useMutationRunnerStatus = (
  options?: UseMutationOptions<unknown, unknown, TRunnerBody[]>
) => useMutation((data) => mutateRunnerStatus(data), options);
